import React from 'react';
import BusinessEvents from '../business/BusinessEvents';
import { useAuth } from '../contexts/AuthContext';

const StaffEvents: React.FC = () => {
  const { user } = useAuth();

  if (!user?.facilityId || !user?.businessId) {
    return <div>No facility assigned. Please contact your administrator.</div>;
  }

  return (
    <div className="staff-events">
      <BusinessEvents facilityId={user.facilityId} businessId={user.businessId} />
    </div>
  );
};

export default StaffEvents; 